export const customerContactFields = [
  'phone', 'wechat', 'wangwang', 'email', 'whatsapp', 'facebook', 'instagram', 'website', 'address',
] as const;

export function isCustomerContactField(field: string): boolean {
  return (customerContactFields as readonly string[]).includes(field);
}

function maskContact(value: string): string {
  const characters = Array.from(value);
  const hidden = Math.ceil(characters.length / 2);
  const start = Math.floor((characters.length - hidden) / 2);
  return characters.slice(0, start).join('') + '*'.repeat(hidden) + characters.slice(start + hidden).join('');
}

// The API enforces privacy. This also protects views from older, unmarked cached responses.
export function protectCustomerContacts<T extends object>(customer: T, role: string): T {
  if (role === 'SUPER_ADMIN') return customer;
  const data = customer as Record<string, unknown>;
  if (data.contactMasked === true || data.sensitiveMasked === true) return customer;
  const protectedCustomer: Record<string, unknown> = { ...data, contactMasked: true };
  for (const field of customerContactFields) {
    if (typeof data[field] === 'string') protectedCustomer[field] = maskContact(data[field]);
  }
  return protectedCustomer as T;
}
